import {
    ECommerceActionHandlers,
    ECommerce as ECommerceBase
} from "@omni/components/components/Product/ECommerce/eCommerce";
import { ECommerceProps } from "@omni/types/components/props/eCommerce.props";

import { SingleStoreCheck } from "./components/singleStoreCheck/singleStoreCheck.component";
import { EcommerceComponent } from "./eCommerce.component";

const ECommerceContainer = ({
    product,
    tooltips,
    infoLink,
    cashbackPagePath,
    contextAwareXfPath,
    paintConfiguratorPath
}: ECommerceProps) => {
    return (
        <ECommerceBase
            product={product}
            tooltips={tooltips}
            infoLink={infoLink}
            cashbackPagePath={cashbackPagePath}
            contextAwareXfPath={contextAwareXfPath}
            paintConfiguratorPath={paintConfiguratorPath}
            handlers={ECommerceActionHandlers}
        >
            <ECommerceBase.Providers>
                <SingleStoreCheck />
                <EcommerceComponent />
            </ECommerceBase.Providers>
        </ECommerceBase>
    );
};

export { ECommerceContainer };
